var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 206,
    viewBox: "0 0 229 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.5 0H208.62C219.72 0 228.73 9.01 228.73 20.12V184.88C228.73 195.98 219.72 205 208.61 205H152.37V20.12C152.38 9.01 161.39 0 172.5 0Z",
    fill: "#8331A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M96.12 62.9883C85.01 62.9883 76 71.9983 76 83.1083V127.988H20.12C9.01 127.988 0 136.998 0 148.108V184.548C0 195.658 9.01 204.668 20.12 204.668H76V205.108H152.36V62.9883H96.12Z",
    fill: "#8331A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228.73,
    height: 205.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.66c73097ce8cc3b54dc01b80b777d62e.svg";
export { ForwardRef as ReactComponent };